import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 11l5 -5l5 5","key":"svg-0"}],["path",{"d":"M7 17l5 -5l5 5","key":"svg-1"}]]

const IconChevronsUp = createReactComponent('outline', 'chevrons-up', 'ChevronsUp', __iconNode);

export default IconChevronsUp;